@if (universityName !== null) {
  <fwc-header-page>
    <div class="motif-page-header-container">
      @if (micrositeTitle) {
        <h1>{{micrositeTitle}}</h1>
      }
      @if (universityHeader && !micrositeTitle && universityName) {
        <h1>Health Insurance for {{universityName}}</h1>
        <h4>{{participationLabel}}</h4>
      }
      @if (!universityHeader && !micrositeTitle) {
        <h1>{{pageTitle}}</h1>
        <h4>{{subTitle}}</h4>
      }
    </div>
  </fwc-header-page>
}
@if (breadcrumbs) {
  <div class="fwc-row">
    <div class="fwc-col-12">
      @if (participantId) {
        <ul class="fwc-breadcrumb top-xs btm-xs" >
          @for (crumb of breadcrumbs; track crumb) {
            @if (crumb.public === true){
              <li [ngClass]="{'active' : crumb.active}"><a href="javascript:;" (click)="navigateTo(participantId.toString() + '/' + (crumb.path === 'home' ? '' : crumb.path))">{{crumb.label}}</a></li>
            }
            @else{
            <li [ngClass]="{'active' : crumb.active}"><a href="javascript:;" (click)="navigateTo(participantId.toString() + '/secure/' + crumb.path)">{{crumb.label}}</a></li>
            }
          }
        </ul>
      }
      @if (storyId) {
        <ul class="fwc-breadcrumb top-xs btm-xs" >
          @for (crumb of breadcrumbs; track crumb) {
            @if (crumb.public === true){
              <li [ngClass]="{'active' : crumb.active}"><a href="javascript:;" (click)="navigateTo('school/' + storyId.toString() + '/' + crumb.path)">{{crumb.label}}</a></li>
            }
            @else{
            <li [ngClass]="{'active' : crumb.active}"><a href="javascript:;" (click)="navigateTo('school/' + storyId.toString() + '/secure/' + crumb.path)">{{crumb.label}}</a></li>
            }
          }
        </ul>
      }
    </div>
  </div>
}
